import { NgFor } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IWorkflowStepBase } from '../../../pages/items/items.interface';
import { StatusCategoryBadgeComponent } from '../status-category-badge/status-category-badge.component';

export interface IStepChoiceDialogData {
  itemKey: string;
  itemTitle: string;
  steps: IWorkflowStepBase[];
}

@Component({
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    NgFor,
    StatusCategoryBadgeComponent,
    TranslateModule,
  ],
  selector: 'app-step-choice-dialog',
  standalone: true,
  styleUrl: './step-choice-dialog.component.scss',
  templateUrl: './step-choice-dialog.component.html',
})
export class StepChoiceDialogComponent {
  public readonly stepChoices: (IWorkflowStepBase & { label: string })[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: IStepChoiceDialogData,
    public readonly dialogRef: MatDialogRef<StepChoiceDialogComponent, number | undefined>,
    private readonly translate: TranslateService,
  ) {
    this.stepChoices = this.data.steps.map((step: IWorkflowStepBase) => ({
      ...step,
      label: step.isDefault ? this.translate.instant(`system.label.${step.name}`) : step.name,
    }));
  }
}
